import React from "react";

export const QuietContactCta = () => {
  return (
    <section
      id="contact"
      data-testid="section-quiet-contact"
      className="relative py-14 lg:py-16 border-t border-white/[0.06] bg-[#020B14]"
    >
      <div className="max-w-[1320px] mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-5">
          <div>
            <div className="mono text-[10px] uppercase tracking-[0.3em] text-slate-500">
              Contact
            </div>
            <p
              data-testid="quiet-contact-line"
              className="mt-3 text-sm sm:text-base text-slate-300"
            >
              Bring a specific decision or handover.{" "}
              <a
                href="https://www.katlastechnology.com/contact/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="quiet-contact-link"
                className="text-white underline underline-offset-4 decoration-white/20 hover:decoration-[#0066FF] hover:text-[#0066FF] transition-colors"
              >
                www.katlastechnology.com/contact
              </a>
            </p>
          </div>
          <div className="text-[12px] text-slate-400">
            <span className="mono text-[10px] uppercase tracking-[0.22em] text-slate-500 mr-2">
              Direct:
            </span>
            <a
              href="mailto:edward.cole@katlastechnology.io"
              data-testid="quiet-contact-email"
              className="text-slate-200 hover:text-white underline underline-offset-4 decoration-white/15 hover:decoration-white/60 transition-colors break-all"
            >
              edward.cole@katlastechnology.io
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
